import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../Components/AuthContext";

// 결정 313: crm.amzinfra.site "기존 관리자로 가기" → /sso#token=<60초 1회용> → 기존 관리자 로그인
const REASONS: Record<string, string> = {
  NO_PERMISSION: "이 매장 관리자 권한이 없어요. 점장에게 crm.amzinfra.site 직원 초대를 요청해 주세요.",
  NO_ACCOUNT: "이 번호로 등록된 관리자 계정이 없어요. crm.amzinfra.site에서 직원 초대를 받은 뒤 다시 들어와 주세요.",
  AMBIGUOUS: "같은 번호의 계정이 여러 개예요. 본사에 문의해 주세요.",
  EXPIRED: "로그인 시간이 지났어요. crm.amzinfra.site에서 다시 눌러 주세요.",
  REPLAYED: "이미 쓴 로그인 링크예요. crm.amzinfra.site에서 다시 눌러 주세요.",
  sso_not_ready: "카카오 관리자 로그인이 아직 준비 중이에요.",
};

const SsoPage = () => {
  const { loginSso } = useAuthContext();
  const navigate = useNavigate();
  const [message, setMessage] = React.useState("로그인 중이에요…");
  const started = React.useRef(false);

  React.useEffect(() => {
    if (started.current) return;
    started.current = true;
    const token = new URLSearchParams(window.location.hash.slice(1)).get("token");
    window.history.replaceState(null, "", window.location.pathname);
    if (!token) {
      setMessage("로그인 정보가 없어요. crm.amzinfra.site에서 다시 눌러 주세요.");
      return;
    }
    // 결정 421: 같은 링크가 두 번 열려도(새 창·카카오톡 브라우저) 서버에는 한 번만 보낸다 — 두 번째는 REPLAYED가 되어 첫 창의 로그인을 가림
    const onceKey = `sso_once_${token.slice(-24)}`;
    try {
      if (localStorage.getItem(onceKey)) {
        setMessage("다른 창에서 로그인하고 있어요. 잠시 뒤 이동합니다…");
        setTimeout(() => navigate("/login", { replace: true }), 1500);
        return;
      }
      localStorage.setItem(onceKey, String(Date.now()));
    } catch {
      // 저장소를 못 쓰는 브라우저는 그대로 진행
    }
    loginSso(token)
      .then(() => {
        document.cookie = "legacy_crm=1; path=/; Secure; SameSite=Lax";
        navigate("/login", { replace: true });
      })
      .catch((e: any) => {
        const code = e?.response?.data?.error;
        setMessage(REASONS[code] || "로그인하지 못했어요. crm.amzinfra.site에서 다시 눌러 주세요.");
      });
  }, [loginSso, navigate]);

  return (
    <div className="auth-page-content mt-5 text-center">
      <p className="text-muted">{message}</p>
    </div>
  );
};

export default SsoPage;
